import { combineReducers } from 'redux';
import { addingBulkGifteeBoxIssueConfigs } from './addingBulkGifteeBoxIssueConfigs';

export const gifteeBoxConfigs = combineReducers({
  addingBulkGifteeBoxIssueConfigs
});
